export enum ContextType {
  StudentData = 'StudentData',
  WorkspaceData = 'WorkspaceData',
  CourseKnowledgeBase = 'CourseKnowledgeBase',
  SpaceData = 'SpaceData',
  ChatData = 'ChatData',
  CareerAdvisorInfo = 'CareerAdvisorInfo',
}
